import router from "./index"
// import store from "../store/index"

router.beforeEach((to, from, next) => {
  const pageTitle = to.meta.title; // 获取即将跳转页面的路由元信息中的标题
  if (pageTitle) {
    document.title = pageTitle; // 将标题赋值给document.title
  }
  to, from
  next()


})